/* Scheme List */
export const SELECTED_SCHEMES = "SELECTED_SCHEMES";
export const SELECTED_SCHEMES_SUCCESS = "SELECTED_SCHEMES_SUCCESS";
export const SELECTED_SCHEMES_FAIL = "SELECTED_SCHEMES_FAIL";
